<template>
  <el-dialog
    title="查看补充资料"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="datum-view" v-loading="loading">
      <div v-if="fileList.length > 0" class="file-grid">
        <div v-for="(item, index) in fileList" :key="index" class="file-item">
          <img
            v-if="!item.endsWith('.pdf')"
            :src="item"
            style="width: 100px; height: 100px; object-fit: cover; cursor: pointer;"
            @click="previewImage(item)"
          />
          <a v-else :href="item" target="_blank" style="color: #409EFF; font-size: 12px;">
            {{ item.split('/').pop() }}
          </a>
        </div>
      </div>
      <el-empty v-else description="暂无补充资料"></el-empty>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </div>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="previewVisible" append-to-body>
      <img :src="previewUrl" style="width: 100%;" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getUnderwriteSupplementList } from '@/api/underwrite-order'

export default {
  name: 'DatumView',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [Number, String, null],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      fileList: [],
      previewVisible: false,
      previewUrl: ''
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  watch: {
    visible(val) {
      if (val && this.orderId) {
        this.fetchData()
      } else {
        this.fileList = []
      }
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await getUnderwriteSupplementList({ id: this.orderId * 1 })
        if (res && res.rows) {
          this.fileList = res.rows.map(item => item.url).filter(Boolean)
        } else {
          this.fileList = []
        }
      } catch (e) {
        this.$message.error('获取补充资料失败')
      } finally {
        this.loading = false
      }
    },
    previewImage(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    handleClose() {
      this.fileList = []
    }
  }
}
</script>

<style lang="less" scoped>
.datum-view {
  min-height: 100px;
  .file-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    .file-item {
      border: 1px solid #eee;
      padding: 5px;
      border-radius: 4px;
    }
  }
}
</style>
